import { render, staticRenderFns } from "./AccessMain.vue?vue&type=template&id=2415507e&scoped=true&"
import script from "./AccessMain.vue?vue&type=script&lang=js&"
export * from "./AccessMain.vue?vue&type=script&lang=js&"
import style0 from "./AccessMain.vue?vue&type=style&index=0&id=2415507e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2415507e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
